const POST_LOGAUDIT = "POST_LOGAUDIT";
const POST_LOGAUDIT_DISABLED = "POST_LOGAUDIT_DISABLED";
const GET_AUDIT = "GET_AUDIT";
const GET_AUDIT_SUCCESS = "GET_AUDIT_SUCCESS";
const GET_AUDIT_FAIL = "GET_AUDIT_FAIL";

const GET_CATEGORIES = "GET_CATEGORIES";
const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
const GET_CATEGORIES_FAIL = "GET_CATEGORIES_FAIL";

const GET_ACTIONS = "GET_ACTIONS";
const GET_ACTIONS_SUCCESS = "GET_ACTIONS_SUCCESS";
const GET_ACTIONS_FAIL = "GET_ACTIONS_FAIL";

const GET_RESOURCES = "GET_RESOURCES";
const GET_RESOURCES_SUCCESS = "GET_RESOURCES_SUCCESS";
const GET_RESOURCES_FAIL = "GET_RESOURCES_FAIL";

const GET_USERS = "GET_USERS";
const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
const GET_USERS_FAIL = "GET_USERS_FAIL";

const DOWNLOAD_USERS = "DOWNLOAD_USERS";
const DOWNLOAD_USERS_SUCCESS = "DOWNLOAD_USERS_SUCCESS";
const DOWNLOAD_USERS_FAIL = "DOWNLOAD_USERS_FAIL";

const initialState = {
  data: [],
  loading: false,
  hasError: false,
  errorMessage: null,
  page: 1,
  totalCount: 0,
  categories: [],
  actions: [],
  resources: [],
  users: [],
  loadingDependencies: false,
};

//Reducer se exporta por default;
export default function audit(state = initialState, action) {
  switch (action.type) {
    case GET_AUDIT: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_AUDIT_SUCCESS: {
      let { data, page, totalCount } = action.payload.data;

      return {
        ...state,
        loading: false,
        data,
        page,
        totalCount,
      };
    }

    case GET_AUDIT_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
        messageError: "An error occurred while obtaining the audit information",
      };
    }

    case GET_CATEGORIES: {
      return {
        ...state,
        loadingDependencies: true,
      };
    }

    case GET_CATEGORIES_SUCCESS: {
      return {
        ...state,
        loadingDependencies: false,
        categories: action.payload.data,
      };
    }

    case GET_CATEGORIES_FAIL: {
      return {
        ...state,
        loadingDependencies: false,
        hasError: true,
        messageError: "An error occurred while obtaining the Categories from Audit",
      };
    }

    case GET_ACTIONS: {
      return {
        ...state,
        loadingDependencies: true,
      };
    }

    case GET_ACTIONS_SUCCESS: {
      return {
        ...state,
        loadingDependencies: false,
        actions: action.payload.data,
      };
    }

    case GET_ACTIONS_FAIL: {
      return {
        ...state,
        loadingDependencies: false,
        hasError: true,
        messageError: "An error occurred while obtaining the Categories from Audit",
      };
    }

    case GET_RESOURCES: {
      return {
        ...state,
        loadingDependencies: true,
      };
    }

    case GET_RESOURCES_SUCCESS: {
      return {
        ...state,
        loadingDependencies: false,
        resources: action.payload.data,
      };
    }

    case GET_RESOURCES_FAIL: {
      return {
        ...state,
        loadingDependencies: false,
        hasError: true,
        messageError: "An error occurred while obtaining the Categories from Audit",
      };
    }

    case GET_USERS: {
      return {
        ...state,
        loadingDependencies: true,
      };
    }

    case GET_USERS_SUCCESS: {
      return {
        ...state,
        loadingDependencies: false,
        users: action.payload.data,
      };
    }

    case GET_USERS_FAIL: {
      return {
        ...state,
        loadingDependencies: false,
        hasError: true,
        messageError: "An error occurred while obtaining the Categories from Audit",
      };
    }

    case DOWNLOAD_USERS: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case DOWNLOAD_USERS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case DOWNLOAD_USERS_FAIL: {
      return {
        ...state,
        isLoading: false,
        hasError: true,
      };
    }

    default:
      return state;
  }
}

export const logFormat = (resource, category, action, details) => {
  return {
    id: 0,
    category,
    action,
    User: "",
    date: new Date(),
    resource,
    details,
  };
};

/**
 * @typedef LogDTO
 * @type {object}
 * @property {number} id Id
 * @property {string} category category
 * @property {string} action action
 * @property {string} user user
 * @property {Date} date date
 * @property {string} resource resource
 * @property {string|null} details details
 * @property {string|null} pathMenu pathMenu
 * @property {number|null} resourceId resourceId
 * @property {number|null} menuItemId menuItemId
 * @property {number|null} tabId tabId
 */

/**
 * @type {LogDTO}
 */
const logDtoDefault = {
  id: 0,
  category: "",
  action: "",
  user: "",
  date: new Date(),
  resource: "",
  details: null,
  pathMenu: null,
  resourceId: null,
  menuItemId: null,
  tabId: null,
};

/**
 * Action To Log Events Customs
 * @param {LogDTO} log resource Accessed
 */
export const actionToLog = (log) => {
  // const data = { ...logDtoDefault, ...log };
  // return {
  //   type: POST_LOGAUDIT,
  //   payload: {
  //     request: {
  //       url: "Logger",
  //       method: "POST",
  //       data,
  //     },
  //   },
  // };
  // Endpoint de telemetria/auditoria desactivado a pedido: POST /api/Logger.

  // Telemetry endpoint disabled: do not send POST /api/Logger.
  // Keep a dispatched action to preserve caller flow without network traffic.
  return { type: POST_LOGAUDIT_DISABLED };
};

/**
 * Action To Log Events Customs
 * @param {string} resource resource Accessed
 * @param {import("material-table").Query} query Query from materialtable
 */
export const getAuditOfLayout = (layoutId, { page = 0, search = null, pageSize = 8 }) => {
  //let params = createParams(query);
  return {
    type: GET_AUDIT,
    payload: {
      request: {
        url: `Logger/${layoutId}?page=${page}${search ? `&search=${search}` : ""}${
          pageSize ? `&pageSize=${pageSize}` : ""
        }`,
        method: "GET",
        //params,
      },
    },
  };
};

/**
 * Action To Log Events Customs
 * @param {string} resource resource Accessed
 * @param {import("material-table").Query} query Query from materialtable
 */
export const getAuditOfCustomRoute = (customRoute, { page = 0, search = null, pageSize = 8 }) => {
  //let params = createParams(query);
  return {
    type: GET_AUDIT,
    payload: {
      request: {
        url: `Logger/Custom/${customRoute}?page=${page}${search ? `&search=${search}` : ""}${
          pageSize ? `&pageSize=${pageSize}` : ""
        }`,
        method: "GET",
        //params,
      },
    },
  };
};

export const getCategories = (layoutId) => {
  return {
    type: GET_CATEGORIES,
    payload: {
      request: {
        url: `Logger/CategoriesFromLayout/${layoutId}`,
        method: "GET",
      },
    },
  };
};
export const getActions = (layoutId) => {
  return {
    type: GET_ACTIONS,
    payload: {
      request: {
        url: `Logger/ActionsFromLayout/${layoutId}`,
        method: "GET",
      },
    },
  };
};

export const getResources = (layoutId) => {
  return {
    type: GET_RESOURCES,
    payload: {
      request: {
        url: `Logger/ResourcesFromLayout/${layoutId}`,
        method: "GET",
      },
    },
  };
};

export const getUsers = (layoutId) => {
  return {
    type: GET_USERS,
    payload: {
      request: {
        url: `Logger/UsersFromLayout/${layoutId}`,
        method: "GET",
      },
    },
  };
};
export const getUsersCustom = (route) => {
  return {
    type: GET_USERS,
    payload: {
      request: {
        url: `Logger/UsersFromLayoutCustom/${route}`,
        method: "GET",
      },
    },
  };
};

export const downloadUsersInfo = (data) => {
  return {
    type: DOWNLOAD_USERS,
    payload: {
      request: {
        url: "Logger/Download",
        method: "POST",
        data: data,
        responseType: "blob",
      },
    },
  };
};
